export default function (Store) {
    const openMobilePayOverlay = (button, returnTarget) => {
        const shell = document.querySelector('[data-content="PersonalFundraisingMobilePayOverlay"]')
        let donationAmounts = []
        let defaultDonationAmount = null
        let fieldVisibility = null

        try {
            donationAmounts = JSON.parse(shell?.dataset?.donationAmounts || '[]')
        } catch {
            donationAmounts = []
        }

        try {
            fieldVisibility = JSON.parse(shell?.dataset?.fieldVisibility || 'null')
        } catch {
            fieldVisibility = null
        }

        const parsedDefault = Number.parseInt(shell?.dataset?.defaultDonationAmount || '', 10)
        if (Number.isFinite(parsedDefault) && parsedDefault > 0) {
            defaultDonationAmount = parsedDefault
        }

        const createDonationPageId = Number.parseInt(button.dataset.createDonationPageId || '', 10)
        const useTestCreditCardRaw =
            shell?.getAttribute?.('data-use-test-credit-card') ??
            shell?.dataset?.useTestCreditCard ??
            ''

        Store.commit('main/set_page_overlay_content_data', {
            fundraisingCampaignId: button.dataset.fundraisingCampaignId || null,
            createDonationPageId: Number.isFinite(createDonationPageId) ? createDonationPageId : null,
            donationAmounts,
            defaultDonationAmount,
            fieldVisibility,
            useTestCreditCard: `${useTestCreditCardRaw}`.trim().toLowerCase() === 'true'
        })
        Store.dispatch('main/openPageOverlay', {
            overlayContent: 'PersonalFundraisingMobilePayOverlay',
            returnTarget
        })
    }

    document.querySelectorAll('.kb-component--personal-fundraising-mobilepay-cta').forEach((button) => {
        button.addEventListener('click', (e) => {
            openMobilePayOverlay(button, e.currentTarget)
        })
    })

    const params = new URLSearchParams(document.location.search)
    if (params.get('openMobilePay') === '1') {
        const button = document.querySelector('.kb-component--personal-fundraising-mobilepay-cta')
        if (button) {
            openMobilePayOverlay(button, button)
            params.delete('openMobilePay')
            const query = params.toString()
            const nextUrl = `${window.location.pathname}${query ? `?${query}` : ''}${window.location.hash}`
            window.history.replaceState({}, '', nextUrl)
        }
    }
}
